<nav class="ftr-schools" [attr.aria-label]="label" (wheel)="onWheel($event)">
    <div class="ftr-chips">
        <button type="button" class="ftr-chip" *ngFor="let group of groups" (click)="selectGroup.emit(group)"
            [class.has-panel]="!logoOf(group) || panel[logoOf(group)]"
            [attr.aria-label]="group.group_name || group.name" [matTooltip]="group.group_name || group.name" matTooltipPosition="above">
            <img *ngIf="logoOf(group)" [src]="logoOf(group)" alt="" loading="lazy">
            <span *ngIf="!logoOf(group)" class="ftr-chip-initial">{{ (group.group_name || group.name || '?').charAt(0) }}</span>
        </button>
    </div>
</nav>
